const serviceNames = {
    rollout_pegasus: true,
    business_tools_kimera: true,
    reviews_kimera: true,
    cms_service: true,
    listings_service: true,
    machine_translation_pegasus: true,
    federation_gql_pegasus: true,
    business_accounts_phoenix: true,
    user_analytics_kimera: true,
    localization_kimera: true,
    gigs_kimera: true,
    briefs_kimera: true,
    personal_assistant_kimera_service: true,
};

export type ServiceName = keyof typeof serviceNames;

export const isValidServiceName = (serviceName: ServiceName) => Object.keys(serviceNames).includes(serviceName);
